/* eslint-disable react/prop-types */
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './styles.module.css';

import {
  OrchestratorImageGenerationService,
  PlanLimitsService,
  ProductService,
  SubscriptionService,
  TargetAudienceService,
  UserPlanCount,
} from '../../../services/';

import { useEffect, useLayoutEffect, useState } from 'react';


import {
  notifyErrorCustom,
  notifyWarningCustom,
  notifyWarningCustom2
} from '../../../utils/notify';

import { useTranslation } from 'react-i18next';
import { getArtGenerationAvailability } from '../../../utils/artConsumption';

import {
  Clips,
  Cross,
  Picture,
  Stars,
  SupermarketCart,
} from '../../../assets/svgs/icons';


import ModalComponent from '../../../components/ModalComponent';
import ModalArtiificialInteligency from './ModalArtificalInteligency';
import ModalUploads from './ModalUploads';

import BackgroundRemoverModal from '../../../components/BackgroundRemoverModal';
import ModalProducts from './ModalProducts';

import { TourGuide } from '../../../components/TourGuide';
import { Beacon, PrimaryButton } from '../../../components';
import { GenerateArtSteps, GenerateArtSteps2, GenerateArtSteps3, GenerateArtSteps4, GenerateArtSteps5 } from './TourGuideSteps';
import { SelectsFormat } from './SelectFormat';
import { SelectsProduct } from './SelectsProduct';

import { AttachReferenceArt } from '../../../components/AttachReferenceArt';
import attachReferenceArtStyles from '../../../components/AttachReferenceArt/styles.module.css';

const STEPS = {
  STEP_FIRST_PASS_HEADLINES: 'stepHeadlines',
  STEP_IMAGE_BANK: 'stepImageBank',
  STEP_THIRD_PASS_PUBLICATION: 'stepPublication',
};

function StepFirstPass({
  isAnimationFinished,
  setStep,
  clientData,
  productRef,
  targetAudienceRef,
  publicationDescriptionRef,
  detailRef,
  funelOfSaleRef,
  setselectFunnel,
  imageArray,
  setImageArray,
  imageGaleryArray,
  setImageGaleryArray,
  imageAIArray,
  setImageAIArray,
  imageUploadArray,
  setImageUploadArray,
  imageProductsArray,
  setImageProductsArray,
  // setGenerateArtIa,
  generateArtIa,
  setSelectedFormat,
  selectedFormat,
  returnToStepRef,
  referenceArt,
  setReferenceArt,
  selectedImageType,
  setSelectedImageType,
}) {
  const navigation = useNavigate();

  const [productTypeOptions, setProductTypeOptions] = useState([]);
  const [productValue, setProductValue] = useState(undefined);


  const [productTargetAudienceOptions, setProductTargetAudienceOptions] =
    useState([]);
  const [targetAudienceValue, setTargetAudienceValue] = useState(undefined);
  const [funnelOfSale, setFunnelOfSale] = useState(undefined);

  const [detailsValue, setDetailsValue] = useState(undefined);
  const [detailsOptions, setDetailsOptions] = useState([]);

  const [publicationDescription, setPublicationDescription] = useState('');
  const [renderTourGuide, setRenderTourGuide] = useState(false)
  const [renderTourGuide2, setRenderTourGuide2] = useState(false)
  const [renderTourGuide3, setRenderTourGuide3] = useState(false)
  const [renderTourGuide4, setRenderTourGuide4] = useState(false)
  const [renderTourGuide5, setRenderTourGuide5] = useState(false)
  const [tourGuide3Finished, setTourGuide3Finished] = useState(false)
  const [tourGuide2Finished, setTourGuide2Finished] = useState(false)
  const [open, setOpen] = useState(false)
  const [showBeacon, setShowBeacon] = useState(false)

  const { t } = useTranslation();
  const storage = window.localStorage;
  const location = useLocation();

  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalAIOpen, setModalAIOpen] = useState(false);
  const [isModalUploadsOpen, setModalUploadsOpen] = useState(false);
  const [isModalProductsOpen, setModalProductsOpen] = useState(false);
  const [isModalImageSelectorOpen, setModalImageSelectorOpen] = useState(false);
  const [imageCategoriesOptions, setImageCategoriesOptions] = useState([
    { label: '', value: '' },
  ]);

  const [openModalCategoryHelp, setOpenModalCategoryHelp] = useState(false);

  const [showProductModal, setShowProductModal] = useState(false);

  const formatOptions = storage.i18nextLng !== 'en' ? [
    {
      id: 1,
      label: 'Feed',
      value: 'quadrado',
      formatDimension: '1024x1024',
    },
    {
      id: 2,
      label: 'Story',
      value: 'vertical',
      formatDimension: '1024x1536',
    },
    {
      id: 3,
      label: 'Horizontal',
      value: 'horizontal',
      formatDimension: '1536x1024',
    },
  ] : [
    {
      id: 1,
      label: 'Feed',
      value: 'quadrado',
      formatDimension: '1024x1024',
    },
    {
      id: 2,
      label: 'Story',
      value: 'vertical',
      formatDimension: '1024x1536',
    },
    {
      id: 3,
      label: 'Horizontal',
      value: 'horizontal',
      formatDimension: '1536x1024',
    },
  ];

  const [showFormatModal, setShowFormatModal] = useState(false);

  useEffect(() => {
    loadDropdownsImageCategory();

  }, []);

  useLayoutEffect(() => {
    // Detecta quando showBeacon é true no state da navegação
    if (location.state?.showBeacon === true) {
      setShowBeacon(true)
    }
  }, [location.state?.showBeacon])

  useLayoutEffect(() => {
    // verifica se deve iniciar o tour guide
    const interval = setTimeout(() => {
      verifyStartTutorial()
    }, 200);

    return () => clearTimeout(interval)
  }, [imageCategoriesOptions])


  const verifyStartTutorial = () => {
    // caso a variavel nao esteja setada na localstorage ou seja true o tutorial inicia
    const shouldRenderTourGuide = localStorage.getItem('showImageGenerationTutorial') !== 'false'
    shouldRenderTourGuide ? setRenderTourGuide(true) : setRenderTourGuide(false)
  }

  const handleFinishTutorial = (status) => {
    if (status === 'skipped') {
      localStorage.setItem('showImageGenerationTutorial', 'false')
      localStorage.setItem('showImageGenerationTutorial2', 'true')
      localStorage.setItem('showImageGenerationTutorial3', 'true')
      localStorage.setItem('showImageGenerationTutorial4', 'true')
      localStorage.setItem('showImageGenerationTutorial5', 'true')
      return
    }

    setTourGuide2Finished(true);
    // finaliza o tutorial e armazena o valor false para que o tutorial não renderize novamente
    if (!open) {
      setOpen(true);
    }
    localStorage.setItem('showImageGenerationTutorial', 'false')
    verifyStartTutorial()
  }

  const handleFinishTutorial3 = (status) => {
    if (status === 'skipped') {
      localStorage.setItem('showImageGenerationTutorial', 'false');
      localStorage.setItem('showImageGenerationTutorial3', 'true');
      localStorage.setItem('showImageGenerationTutorial4', 'true')
      localStorage.setItem('showImageGenerationTutorial5', 'true')
      return;
    }
    if (!open) {
      setOpen(true);
    }
    localStorage.setItem('showImageGenerationTutorial', 'false')
    verifyStartTutorial()
    setTourGuide3Finished(true);
  }

  const handleTourCallback = (data) => {
    const { action, index } = data;

    // Se finalizou ou pulou
    if (action === 'close' && index === 3) {
      setOpen(true);
    }
  };

  const handleFinishFirstTutorial = (status) => {
    if (status === 'skipped') {
      localStorage.setItem('showImageGenerationTutorial', 'false')
      localStorage.setItem('showImageGenerationTutorial2', 'true')
      localStorage.setItem('showImageGenerationTutorial3', 'true')
      localStorage.setItem('showImageGenerationTutorial4', 'true')
      localStorage.setItem('showImageGenerationTutorial5', 'true')
      return
    }
    // Garante que o menu esteja aberto antes de iniciar o segundo tutorial
    if (!open) {
      setOpen(true);
    }

    // Aguarda um pequeno delay para garantir que o menu foi renderizado
    setTimeout(() => {
      setRenderTourGuide2(true);
    }, 300);
  };

  const loadDropdownsImageCategory = async () => {
    const dataCategories =
      storage.i18nextLng !== 'en'
        ? [
          { label: 'Principal', value: 'Principal' },
          { label: 'Background', value: 'Background' },
        ]
        : [
          { label: 'Main', value: 'Principal' },
          { label: 'Background', value: 'Background' },
        ];

    setImageCategoriesOptions(dataCategories);
  };

  const handleOpenModal = (modal) => {
    if (
      generateArtIa &&
      (imageUploadArray.length > 0 ||
        imageArray.length > 0 ||
        imageGaleryArray.length > 0 ||
        imageAIArray.length > 0 ||
        imageProductsArray.length > 0)
    ) {
      notifyErrorCustom(t('new_publication_page_second_pass_image_ai_error'));
      return;
    }
    if (modal === 'galeria') {
      setModalOpen(true);
    }
    if (modal === 'inteligenciaArtificial') {
      setModalAIOpen(true);
    }
    if (modal === 'uploads') {
      setModalUploadsOpen(true);
    }
    if (modal === 'produtos') {
      setModalProductsOpen(true);
    }
  };

  const handleCloseModal = (modal) => {
    if (modal === 'galeria') {
      setModalOpen(false);
    }
    if (modal === 'inteligenciaArtificial') {
      setModalAIOpen(false);
    }
    if (modal === 'uploads') {
      setModalUploadsOpen(false);
    }
    if (modal === 'produtos') {
      setModalProductsOpen(false);
    }
    if (modal === 'categoryHelp') {
      setOpenModalCategoryHelp(false);
    }
  };

  const handleOpenImageSelectorModal = (type) => {
    setSelectedImageType(type);
    setModalImageSelectorOpen(true);

    const hasSeenTourGuide4 = localStorage.getItem('showImageGenerationTutorial4') === 'true';

    if (tourGuide3Finished && !renderTourGuide4 && !hasSeenTourGuide4) {
      setTimeout(() => {
        // Aguarda o modal renderizar completamente
        setTimeout(() => {
          setRenderTourGuide4(true);
        }, 500);
      }, 300);
    }
  };

  const handleCloseImageSelectorModal = () => {
    setModalImageSelectorOpen(false);
    //setSelectedImageType(null);

    const hasSeenTourGuide5 = localStorage.getItem('showImageGenerationTutorial5') === 'true';

    if (tourGuide3Finished && !renderTourGuide5 && !renderTourGuide4 && !hasSeenTourGuide5) {
      setTimeout(() => {
        // Aguarda o modal fechar completamente
        setRenderTourGuide5(true);
      }, 300);
    }
  };

  const handleSelectImageSource = (modalType) => {
    handleOpenModal(modalType);
  };


  const handleSetImageGaleryArray = (images) => {
    if (selectedImageType && images && Array.isArray(images) && images.length > 0) {
      const category = selectedImageType === 'Principal' ? 'Principal' : 'Background';

      const isCategoryAwreadyFilled = getAllImagesByCategory(category).length > 0;

      if (isCategoryAwreadyFilled) {
        notifyErrorCustom('Você ja escolheu uma imagem ' + category)
        handleCloseModal('galeria')
        handleCloseImageSelectorModal();
        return
      }

      images = images.slice(0, 1)

      const imagesWithCategory = images.map(image => ({
        ...image,
        categoryId: category
      }));

      setImageGaleryArray(prev => [...prev, ...imagesWithCategory]);
    } else {
      setImageGaleryArray(images);
    }
    handleCloseImageSelectorModal();

    handleCloseModal('galeria');
  };

  const handleSetImageAIArray = (images) => {
    if (selectedImageType && images && Array.isArray(images) && images.length > 0) {
      const category = selectedImageType === 'Principal' ? 'Principal' : 'Background';

      const isCategoryAwreadyFilled = getAllImagesByCategory(category).length > 0;

      if (isCategoryAwreadyFilled) {
        notifyErrorCustom('Você ja escolheu uma imagem ' + category)
        handleCloseModal('inteligenciaArtificial')
        handleCloseImageSelectorModal();
        return
      }

      images = images.slice(0, 1)

      const imagesWithCategory = images.map(image => ({
        ...image,
        categoryId: category
      }));

      setImageAIArray(prev => [...prev, ...imagesWithCategory]);
    } else {
      setImageAIArray(images);
    }
    handleCloseImageSelectorModal();
    handleCloseModal('inteligenciaArtificial');
  };

  const handleSetImageUploadArray = (images) => {
    if (selectedImageType && images && Array.isArray(images) && images.length > 0) {

      const isCategoryAwreadyFilled = getAllImagesByCategory(category).length > 0;

      if (isCategoryAwreadyFilled) {
        notifyErrorCustom('Você ja escolheu uma imagem ' + category)
        handleCloseModal('uploads')
        handleCloseImageSelectorModal();
        return
      }

      images = images.slice(0, 1)

      const category = selectedImageType === 'Principal' ? 'Principal' : 'Background';
      const imagesWithCategory = images.map(image => ({
        ...image,
        categoryId: category
      }));

      setImageUploadArray(prev => {
        const filtered = prev.filter(img => img.categoryId !== category);
        return [...filtered, ...imagesWithCategory];
      });
    } else {
      setImageUploadArray(images);
    }
    handleCloseImageSelectorModal();
    handleCloseModal('uploads');
  };

  const handleSetImageProductsArray = (images) => {
    if (selectedImageType && images && Array.isArray(images) && images.length > 0) {
      const category = selectedImageType === 'Principal' ? 'Principal' : 'Background';

      const isCategoryAwreadyFilled = getAllImagesByCategory(category).length > 0;

      if (isCategoryAwreadyFilled) {
        notifyErrorCustom('Você ja escolheu uma imagem ' + category)
        handleCloseModal('produtos')
        handleCloseImageSelectorModal();
        return
      }

      images = images.slice(0, 1)

      const imagesWithCategory = images.map(image => ({
        ...image,
        categoryId: category
      }));

      setImageProductsArray(prev => {
        const filtered = prev.filter(img => img.categoryId !== category);
        return [...filtered, ...imagesWithCategory];
      });
    } else {
      setImageProductsArray(images);
    }
    handleCloseImageSelectorModal();
    handleCloseModal('produtos');
  };


  const getAllImagesByCategory = (category) => {
    const allImages = [
      ...imageArray,
      ...imageGaleryArray,
      ...imageAIArray,
      ...imageUploadArray,
      ...imageProductsArray
    ];

    const images = allImages.filter(img => img.categoryId === category);

    return images.map(image => {
      if (image.fileDataBase64) return image.fileDataBase64;
      if (image.image) return image.image;
      if (image.base64) return 'data:image/png;base64,' + image.base64;
      if (image.url) return image.url;
      return null;
    }).filter(url => url !== null);
  };

  const hasBackgroundImage = () => {
    return getAllImagesByCategory('Background').length > 0;
  };

  const clearBackgroundImages = () => {
    setImageArray(prev => prev.filter(img => img.categoryId !== 'Background'));
    setImageGaleryArray(prev => prev.filter(img => img.categoryId !== 'Background'));
    setImageAIArray(prev => prev.filter(img => img.categoryId !== 'Background'));
    setImageUploadArray(prev => prev.filter(img => img.categoryId !== 'Background'));
    setImageProductsArray(prev => prev.filter(img => img.categoryId !== 'Background'));
  };

  const UnifiedImagePreviews = () => {
    const principalImages = getAllImagesByCategory('Principal');

    const backgroundImages = getAllImagesByCategory('Background');

    const hasReferenceArt = referenceArt && referenceArt.base64;

    if (!hasReferenceArt && principalImages.length === 0 && backgroundImages.length === 0) {
      return null;
    }

    return (
      <>
        {(hasReferenceArt || principalImages.length > 0 || backgroundImages.length > 0) && (
          <div
            style={{
              position: 'absolute',
              bottom: '100%',
              marginBottom: '16px',
              display: 'flex',
              flexDirection: 'row',
              gap: '10px',
              alignItems: 'center',
              justifyContent: 'flex-start',
              flexWrap: 'wrap',
              zIndex: 10,
              width: 'max-content',
              maxWidth: '90vw',
            }}
          >
            {hasReferenceArt && (
              <div
                className={attachReferenceArtStyles.image_preview_container_flex}
                style={{
                  border: '2px solid #FF2F00',
                }}
              >
                <img
                  src={referenceArt.base64}
                  alt="Referência"
                  className={attachReferenceArtStyles.preview_image}
                />
                <button
                  className={attachReferenceArtStyles.remove_image_button}
                  onClick={() => setReferenceArt(null)}
                  type="button"
                  title="Remover imagem"
                  aria-label="Remover imagem"
                >
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </div>
            )}

            {principalImages?.map((imageSrc, index) => {
              const allImages = [
                ...imageArray,
                ...imageGaleryArray,
                ...imageAIArray,
                ...imageUploadArray,
                ...imageProductsArray
              ];
              const imageObj = allImages.find(img => {
                const imgSrc = img.fileDataBase64 || img.image || (img.base64 ? 'data:image/png;base64,' + img.base64 : null) || img.url;
                return imgSrc === imageSrc && img.categoryId === 'Principal';
              });

              return (
                <div
                  key={`principal-${index}`}
                  className={attachReferenceArtStyles.image_preview_container_flex}
                  style={{
                    border: '2px solid #6A0098',
                  }}
                >
                  <img
                    src={imageSrc}
                    alt="Principal"
                    className={attachReferenceArtStyles.preview_image}
                  />
                  <button
                    className={attachReferenceArtStyles.remove_image_button}
                    onClick={() => {
                      if (imageArray.some(img => img === imageObj)) {
                        setImageArray(prev => prev.filter(img => img !== imageObj));
                      } else if (imageGaleryArray.some(img => img === imageObj)) {
                        setImageGaleryArray(prev => prev.filter(img => img !== imageObj));
                      } else if (imageAIArray.some(img => img === imageObj)) {
                        setImageAIArray(prev => prev.filter(img => img !== imageObj));
                      } else if (imageUploadArray.some(img => img === imageObj)) {
                        setImageUploadArray(prev => prev.filter(img => img !== imageObj));
                      } else if (imageProductsArray.some(img => img === imageObj)) {
                        setImageProductsArray(prev => prev.filter(img => img !== imageObj));
                      }
                    }}
                    type="button"
                    title="Remover imagem"
                    aria-label="Remover imagem"
                  >
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
              );
            })}

            {backgroundImages.map((imageSrc, index) => {
              const allImages = [
                ...imageArray,
                ...imageGaleryArray,
                ...imageAIArray,
                ...imageUploadArray,
                ...imageProductsArray
              ];
              const imageObj = allImages.find(img => {
                const imgSrc = img.fileDataBase64 || img.image || (img.base64 ? 'data:image/png;base64,' + img.base64 : null) || img.url;
                return imgSrc === imageSrc && img.categoryId === 'Background';
              });

              return (
                <div
                  key={`background-${index}`}
                  className={attachReferenceArtStyles.image_preview_container_flex}
                  style={{
                    border: '2px solid #FDA335',
                  }}
                >
                  <img
                    src={imageSrc}
                    alt="Background"
                    className={attachReferenceArtStyles.preview_image}
                  />
                  <button
                    className={attachReferenceArtStyles.remove_image_button}
                    onClick={() => {
                      if (imageArray.some(img => img === imageObj)) {
                        setImageArray(prev => prev.filter(img => img !== imageObj));
                      } else if (imageGaleryArray.some(img => img === imageObj)) {
                        setImageGaleryArray(prev => prev.filter(img => img !== imageObj));
                      } else if (imageAIArray.some(img => img === imageObj)) {
                        setImageAIArray(prev => prev.filter(img => img !== imageObj));
                      } else if (imageUploadArray.some(img => img === imageObj)) {
                        setImageUploadArray(prev => prev.filter(img => img !== imageObj));
                      } else if (imageProductsArray.some(img => img === imageObj)) {
                        setImageProductsArray(prev => prev.filter(img => img !== imageObj));
                      }
                    }}
                    type="button"
                    title="Remover imagem"
                    aria-label="Remover imagem"
                  >
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </>
    );
  };

  // const handleHelpCategory = () => {
  //   setOpenModalCategoryHelp(true);
  // };

  const nextButton = async (navigation) => {
    if (
      generateArtIa &&
      navigation === 'imageBank' &&
      (imageUploadArray.length > 0 ||
        imageArray.length > 0 ||
        imageGaleryArray.length > 0 ||
        imageAIArray.length > 0 ||
        imageProductsArray.length > 0)
    ) {
      notifyErrorCustom(t('new_publication_page_second_pass_image_ai_error'));
      return;
    }
    if (navigation === 'back') {
      setStep(STEPS.STEP_FIRST_PASS_HEADLINES);
    }
    if (navigation === 'next') {
      setStep(STEPS.STEP_THIRD_PASS_PUBLICATION);
    }
    if (navigation === 'imageBank') {
      setStep(STEPS.STEP_IMAGE_BANK);
    }
  };

  const validateForm = () => {
    if (!publicationDescription) {
      notifyErrorCustom(
        t('new_publication_page_first_pass_description_required')
      );
      return false;
    }
    return true;
  };

  useEffect(() => {
    loadProductServiceData();
    loadtargetAudienceData();
    loadDetailsData();

    if (productRef.current) {
      setProductValue(productRef.current);
    }

    if (targetAudienceRef.current) {
      setTargetAudienceValue(targetAudienceRef.current);
    }

    if (funelOfSaleRef.current) {
      setselectFunnel(funelOfSaleRef.current.value);
      setFunnelOfSale(funelOfSaleRef.current.value);
    }

    if (detailRef.current) {
      setDetailsValue(detailRef.current);
    }

    if (publicationDescriptionRef.current) {
      setPublicationDescription(publicationDescriptionRef.current);
    }
  }, [clientData]);

  const loadDetailsData = async () => {
    setDetailsOptions([
      {
        value: 'Simples',
        label: 'Simples',
      },
      {
        value: 'Mediana',
        label: 'Mediana',
      },
      {
        value: 'Avançado',
        label: 'Avançado',
      },
    ]);
  };

  useEffect(() => {
    returnToStepRef.current = false;
  }, []);

  const loadProductServiceData = async () => {
    if (!clientData?.uuid) {
      const { data, responseStatus } =
        await ProductService.getProductByNotBusinessClientList();

      const nothingProduct = {
        label: storage.i18nextLng !== 'en' ? 'Nenhum' : 'None',
        value: null,
      };

      if (responseStatus === 200) {
        const options = data.map((item) => ({
          ...item,
          price: item.value,
          label: item.name,
          value: item.uuid,
        }));

        const productTypeOptions = [nothingProduct, ...options];

        setProductTypeOptions(productTypeOptions);
      }
    } else {
      const { data, responseStatus } =
        await ProductService.getProductByBusinessClientIdList(clientData?.uuid);
      if (responseStatus === 200)
        setProductTypeOptions(
          data.map((item) => ({
            ...item,
            price: item.value,
            label: item.name,
            value: item.uuid,
          }))
        );
    }
  };

  const loadtargetAudienceData = async () => {
    if (!clientData?.uuid) {
      const { data, responseStatus } =
        await TargetAudienceService.getAllTargetAudienceByNotClientId(
          storage.i18nextLng == 'en' ? storage.i18nextLng : 'ptBR'
        );

      const nothingTargetAudience = {
        label: 'Nenhum',
        value: null,
      };

      if (responseStatus === 200) {
        const options = data.map((item) => ({
          ...item,
          label: item.name,
          value: item.uuid,
        }));

        // Adicione nothingProduct como o primeiro objeto na matriz de opções
        const productTypeOptions = [nothingTargetAudience, ...options];

        setProductTargetAudienceOptions(productTypeOptions);
      }
    } else {
      const { data, responseStatus } =
        await TargetAudienceService.getAllTargetAudienceByClientId(
          clientData?.uuid
        );

      if (responseStatus === 200)
        setProductTargetAudienceOptions(
          data.map((item) => ({
            ...item,
            label: item.name,
            value: item.uuid,
          }))
        );
    }

    setTargetAudienceValue(targetAudienceRef.current?.value);
  };

  const HeaderStepRender = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        {/* <div className={styles.title_new_posts}>
          <p className={styles.title_new_posts_label}>
            {t('new_publication_page_new')}
          </p>
          <p className={styles.title_new_posts_title}>
            {t('new_publication_page_post')}
          </p>
        </div> */}

        {/* <div
          onClick={() => {
            navigation('/ChatSocket');
          }}
          style={{
            cursor: 'pointer',
            marginRight: 28,
            border: '1px solid #FF2F00',

            padding: '0px 18px',
            borderRadius: '100px',

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 14,
          }}
        >
          <Cross color="#FF2F00" />
          <p
            style={{
              fontSize: 14,
              fontWeight: 500,

              fontFamily: 'Poppins',

              margin: 0,
              padding: 0,
            }}
          >
            {t('new_publication_page_ia_button_cancel')}
          </p>
        </div> */}
      </div>
    );
  };

  const nextButtonClick = async () => {
    const { hasAvailableArts } = await getArtGenerationAvailability(1);

    if (!hasAvailableArts) {
      notifyWarningCustom(
        t('plans.user_plan_count_no_available_arts_to_generate')
      );
      return;
    }

    if (!validateForm()) return;

    // let checkMainCategory = false;

    if (
      generateArtIa &&
      imageUploadArray.length <= 0 &&
      imageArray.length <= 0 &&
      imageGaleryArray.length <= 0 &&
      imageAIArray.length <= 0 &&
      imageProductsArray.length <= 0
    ) {
      notifyErrorCustom(
        t('new_publication_page_second_pass_image_ai_error_title')
      );
      return;
    }

    for (const image of imageArray) {
      if (generateArtIa) {
        image.categoryId = 'Background';
      } else {
        if (!image.categoryId) {
          notifyErrorCustom(
            t('new_publication_page_second_pass_image_ai_error_subtitle')
          );
          return;
        } else if (image.categoryId == 'Principal') {
          // checkMainCategory = true;
        }
      }
    }

    for (const image of imageAIArray) {
      if (generateArtIa) {
        image.categoryId = 'Background';
      } else {
        if (!image.categoryId) {
          notifyErrorCustom(
            t('new_publication_page_second_pass_image_ai_error_subtitle')
          );
          return;
        } else if (image.categoryId == 'Principal') {
          // checkMainCategory = true;
        }
      }
    }

    for (const image of imageGaleryArray) {
      if (generateArtIa) {
        image.categoryId = 'Background';
      } else {
        if (!image.categoryId) {
          notifyErrorCustom(
            t('new_publication_page_second_pass_image_ai_error_subtitle')
          );
          return;
        } else if (image.categoryId == 'Principal') {
          // checkMainCategory = true;
        }
      }
    }

    for (const image of imageUploadArray) {
      if (generateArtIa) {
        image.categoryId = 'Background';
      } else {
        if (!image.categoryId) {
          notifyErrorCustom(
            t('new_publication_page_second_pass_image_ai_error_subtitle')
          );
          return;
        } else if (image.categoryId == 'Principal') {
          // checkMainCategory = true;
        }
      }
    }

    for (const image of imageProductsArray) {
      if (generateArtIa) {
        image.categoryId = 'Background';
      } else {
        if (!image.categoryId) {
          notifyErrorCustom(
            t('new_publication_page_second_pass_image_ai_error_subtitle')
          );
          return;
        } else if (image.categoryId == 'Principal') {
          // checkMainCategory = true;
        }
      }
    }

    setStep('stepSubtitles');
  };

  const ImageModals = () => {

    return (
      <>
        {/* Modal de Galeria */}
        <ModalComponent
          isOpen={isModalOpen}
          onClose={() => handleCloseModal('galeria')}
          className={styles.teste}
        >
          <BackgroundRemoverModal
            onCloseModal={handleSetImageGaleryArray}
            closeModal={handleCloseModal}
            imageArray={imageGaleryArray}
            selectedImageType={selectedImageType}
          />
        </ModalComponent>

        {/* Modal de Inteligência Artificial */}
        <ModalComponent
          isOpen={isModalAIOpen}
          onClose={() => handleCloseModal('inteligenciaArtificial')}
          className={styles.teste}
        >
          <ModalArtiificialInteligency
            setImageAIArray={handleSetImageAIArray}
            closeModal={handleCloseModal}
            selectedImageType={selectedImageType}
            imageArray={imageArray}
          />
        </ModalComponent>

        {/* Modal de Uploads */}
        <ModalComponent
          isOpen={isModalUploadsOpen}
          onClose={() => handleCloseModal('uploads')}
          className={styles.teste}
        >
          <ModalUploads
            closeModal={handleCloseModal}
            setImageUploadArray={handleSetImageUploadArray}
          />
        </ModalComponent>

        {/* Modal de Produtos */}
        <ModalComponent
          isOpen={isModalProductsOpen}
          onClose={() => handleCloseModal('produtos')}
          className={styles.teste}
        >
          <ModalProducts
            closeModal={handleCloseModal}
            setImageProductsArray={handleSetImageProductsArray}
          />
        </ModalComponent>


        {/* Modal 2x2 para seleção de fonte de imagem */}
        <ModalComponent
          isOpen={isModalImageSelectorOpen}
          onClose={handleCloseImageSelectorModal}
          className={styles.teste}
          overlayStyle={{ zIndex: 10 }}
        >
          <div
            id="image-selector-item"
            style={{
              padding: '50px',
              display: 'flex',
              flexDirection: 'column',
              gap: '40px',
              alignItems: 'center',
              maxWidth: '900px',
              width: '100%',
              position: 'relative',
            }}
          >
            <button
              onClick={handleCloseImageSelectorModal}
              style={{
                position: 'absolute',
                top: '5px',
                right: '5px',
                background: 'transparent',
                border: 'none',
                fontSize: '22px',
                cursor: 'pointer',
                color: '#190027',
                width: '30px',
                height: '30px',
                minWidth: '30px',
                minHeight: '30px',
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                transition: 'background-color 0.2s ease',
                zIndex: 1000,
                lineHeight: '1',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f0f0f0';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
              }}
              aria-label="Fechar modal"
            >
              ×
            </button>

            <div
              style={{
                display: 'flex',
                gap: '79px',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
              }}
            >
              {/* Botão Galeria */}
              <div
                style={{
                  boxShadow: '0px 14px 40px 2px #6A009880',
                  borderRadius: '40px',
                  width: '100%',
                  maxWidth: '100%',
                  overflow: 'hidden',
                  boxSizing: 'border-box',
                }}
              >
                <div
                  className={styles.box_image}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelectImageSource('galeria');
                  }}
                  style={{
                    background:
                      'linear-gradient(170deg, #6A0098 45%, #9F00E4 100%)',
                    boxShadow: '-3px 4px 13.9px 0px #FFFFFF59 inset',
                    cursor: 'pointer',
                    position: 'relative',
                    zIndex: 10,
                    width: '100%',
                    minWidth: '220px',
                    height: '200px',
                    padding: '30px',
                    boxSizing: 'border-box',
                  }}
                >
                  <div className={styles.box_image_svg}>
                    <Clips width={40} height={40} />
                  </div>
                  <div className={styles.box_image_text}>
                    <p className={styles.box_image_title}>
                      {t('new_publication_page_second_pass_galery')}
                    </p>
                  </div>
                </div>
              </div>

              {/* Botão Banco de Imagens */}
              <div
                style={{
                  boxShadow: '0px 14px 40px 2px #6A009880',
                  borderRadius: '40px',
                  width: '100%',
                  maxWidth: '100%',
                  overflow: 'hidden',
                  boxSizing: 'border-box',
                }}
              >
                <div
                  className={styles.box_image}
                  onClick={(e) => {
                    e.stopPropagation();
                    setModalImageSelectorOpen(false);
                    nextButton('imageBank');
                  }}
                  style={{
                    background:
                      'linear-gradient(170deg, #6A0098 45%, #9F00E4 100%)',
                    boxShadow: '-3px 4px 13.9px 0px #FFFFFF59 inset',
                    cursor: 'pointer',
                    position: 'relative',
                    zIndex: 10,
                    width: '100%',
                    minWidth: '220px',
                    height: '200px',
                    padding: '30px',
                    boxSizing: 'border-box',
                  }}
                >
                  <div className={styles.box_image_svg}>
                    <Picture size={40} />
                  </div>
                  <div className={styles.box_image_text}>
                    <p className={styles.box_image_title}>
                      {t('new_publication_page_second_pass_bank_of_image')}
                    </p>
                  </div>
                </div>
              </div>

              {/* Botão Inteligência Artificial */}
              <div
                style={{
                  boxShadow: '0px 14px 40px 2px #6A009880',
                  borderRadius: '40px',
                  width: '100%',
                  maxWidth: '100%',
                  overflow: 'hidden',
                  boxSizing: 'border-box',
                }}
              >
                <div
                  className={styles.box_image}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelectImageSource('inteligenciaArtificial');
                  }}
                  style={{
                    background:
                      'linear-gradient(170deg, #6A0098 45%, #9F00E4 100%)',
                    boxShadow: '-3px 4px 13.9px 0px #FFFFFF59 inset',
                    cursor: 'pointer',
                    position: 'relative',
                    zIndex: 10,
                    width: '100%',
                    minWidth: '220px',
                    height: '200px',
                    padding: '30px',
                    boxSizing: 'border-box',
                  }}
                >
                  <div className={styles.box_image_svg}>
                    <Stars width={40} height={40} />
                  </div>
                  <div className={styles.box_image_text}>
                    <p className={styles.box_image_title}>
                      {t('new_publication_page_second_pass_ia')}
                    </p>
                  </div>
                </div>
              </div>

              {/* Botão Produtos */}
              {/* <div
                style={{
                  boxShadow: '0px 14px 40px 2px #6A009880',
                  borderRadius: '40px',
                  width: '100%',
                  maxWidth: '100%',
                  overflow: 'hidden',
                  boxSizing: 'border-box',
                }}
              >
                <div
                  className={styles.box_image}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelectImageSource('produtos');
                  }}
                  style={{
                    background:
                      'linear-gradient(170deg, #6A0098 45%, #9F00E4 100%)',
                    boxShadow: '-3px 4px 13.9px 0px #FFFFFF59 inset',
                    cursor: 'pointer',
                    position: 'relative',
                    zIndex: 10,
                    width: '100%',
                    minWidth: '220px',
                    height: '200px',
                    padding: '30px',
                    boxSizing: 'border-box',
                  }}
                >
                  <div className={styles.box_image_svg}>
                    <SupermarketCart width={40} height={40} />
                  </div>
                  <div className={styles.box_image_text}>
                    <p className={styles.box_image_title}>
                      {t('new_publication_page_second_pass_products')}
                    </p>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </ModalComponent>
      </>
    );
  };

  const FooterStepRender = () => {
    return (
      <div className={styles.generateArtButtonWrapper}>
        <button
          id='generate-art-btn'
          className={styles.generateArtButton}
          onClick={() => {
            nextButtonClick();
          }}
        >
          <span>
            {t('new_publication_page_ia_button_generate_art')}
          </span>
          {/* <Stars color="#fff" width={26} height={26} /> */}
        </button>
      </div>
    );
  };

  return (
    <div className={styles.container_header}>
      {renderTourGuide && isAnimationFinished && (
        <TourGuide
          isOpen={renderTourGuide}
          onFinish={handleFinishFirstTutorial}
          onNext={(event) => handleTourCallback(event)}
          steps={GenerateArtSteps.map((e, i) => ({
            ...e,
            content: t(e.content),
            locale: {
              back: t(e.locale.back),
              next: t(e.locale.next),
              skip: t(e.locale.skip),
              last: t(i === GenerateArtSteps.length - 1 ? e.locale.close : e.locale.last),
              close: t(i === GenerateArtSteps.length - 1 ? e.locale.close : e.locale.last),
            }
          }))} />
      )}
      {renderTourGuide2 && isAnimationFinished && (
        <TourGuide
          isOpen={renderTourGuide2}
          onFinish={(status) => handleFinishTutorial(status)}
          onNext={() => { }}
          steps={GenerateArtSteps2.map((e, i) => ({
            ...e,
            content: t(e.content),
            locale: {
              back: t(e.locale.back),
              next: t(e.locale.next),
              skip: t(e.locale.skip),
              last: t(i === GenerateArtSteps2.length - 1 ? e.locale.close : e.locale.last),
              close: t(i === GenerateArtSteps2.length - 1 ? e.locale.close : e.locale.last),
            }
          }))} />
      )}
      {renderTourGuide3 && isAnimationFinished && (
        <TourGuide
          isOpen={renderTourGuide3}
          onFinish={(status) => handleFinishTutorial3(status)}
          onNext={() => { }}
          steps={GenerateArtSteps3.map((e, i) => ({
            ...e,
            content: t(e.content),
            locale: {
              back: t(e.locale.back),
              next: t(e.locale.next),
              skip: t(e.locale.skip),
              last: t(i === GenerateArtSteps3.length - 1 ? e.locale.close : e.locale.last),
              close: t(i === GenerateArtSteps3.length - 1 ? e.locale.close : e.locale.last),
            }
          }))} />
      )}
      {renderTourGuide4 && isAnimationFinished && (
        <TourGuide
          isOpen={renderTourGuide4}
          onFinish={() => {
            setRenderTourGuide4(false);
            localStorage.setItem('showImageGenerationTutorial4', 'true');
          }}
          onNext={() => { }}
          steps={GenerateArtSteps4.map((e, i) => ({
            ...e,
            content: t(e.content),
            locale: {
              back: t(e.locale.back),
              next: t(e.locale.next),
              skip: t(e.locale.skip),
              last: t(i === GenerateArtSteps4.length - 1 ? e.locale.close : e.locale.last),
              close: t(i === GenerateArtSteps4.length - 1 ? e.locale.close : e.locale.last),
            }
          }))} />
      )}
      {renderTourGuide5 && isAnimationFinished && (
        <TourGuide
          isOpen={renderTourGuide5}
          onFinish={() => {
            setRenderTourGuide5(false);
            localStorage.setItem('showImageGenerationTutorial5', 'true');
          }}
          onNext={() => { }}
          steps={GenerateArtSteps5.map((e, i) => ({
            ...e,
            content: t(e.content),
            locale: {
              back: t(e.locale.back),
              next: t(e.locale.next),
              skip: t(e.locale.skip),
              last: t(i === GenerateArtSteps5.length - 1 ? e.locale.close : e.locale.last),
              close: t(i === GenerateArtSteps5.length - 1 ? e.locale.close : e.locale.last),
            }
          }))} />
      )}



      <HeaderStepRender />
      <div className={styles.generateArtContent}>
        <div className={styles.generateArtInner}>
          <div className={styles.titleBlock}>
            <p className={styles.container_content_imagem_subtitle}>
              {t('new_publication_page_ia_step_first_title')}{' '}
              <span className={styles.gradient_text}> {t('new_publication_page_ia_step_first_title_part_two')} {t('new_publication_page_ia_step_first_title_part_three')}</span>
            </p>
            <span className={styles.container_content_imagem_subtitle_2}>{t('new_publication_page_ia_step_first_subtitle')}</span>
          </div>

          <div id="input-image-prompt" className={styles.inputPill}>
            <div className={styles.inputPillInner}>
              <div style={{ position: 'relative', flexShrink: 0 }}>
                <UnifiedImagePreviews />
                <AttachReferenceArt
                  setOpen={setOpen}
                  open={open}
                  onSubmenuOpen={() => {
                    const hasSeenTourGuide3 = localStorage.getItem('showImageGenerationTutorial3') === 'true';
                    if (!renderTourGuide3 && !hasSeenTourGuide3 && tourGuide2Finished) {
                      setTimeout(() => {
                        setRenderTourGuide3(true);
                        localStorage.setItem('showImageGenerationTutorial3', 'true');
                      }, 400);
                    }
                  }}
                  onImageSelect={(imageData) => {
                    if (hasBackgroundImage()) {
                      clearBackgroundImages();
                      const message = t('reference_art_background_conflict_removed')
                      notifyErrorCustom(message);
                    }
                    setReferenceArt(imageData);
                  }}
                  options={[
                    {
                      id: 'reference',
                      label: t('attach_reference_art.attach_label'),
                      description: t('attach_reference_art.reference_art_desc'),
                      onSelect: (imageData) => {
                        if (hasBackgroundImage()) {
                          clearBackgroundImages();
                          const message = t('reference_art_background_conflict_removed')
                          notifyErrorCustom(message);
                        }
                        setReferenceArt(imageData);
                      }
                    },
                    {
                      id: 'type',
                      label: t('attach_reference_art.images_label'),
                      submenu: [
                        {
                          label: t('attach_reference_art.main_image_label'),
                          description: t('attach_reference_art.main_image_desc'),
                          onSelect: () => {
                            getAllImagesByCategory('Principal').length < 1 ?
                              handleOpenImageSelectorModal('Principal') : notifyErrorCustom(t('attach_reference_art.main_image_only_one'));
                          }
                        },
                        {
                          label: t('attach_reference_art.background_image_label'),
                          description: t('attach_reference_art.background_image_desc'),
                          onSelect: () => {
                            if (referenceArt && referenceArt.base64) {
                              const message = t('reference_art_background_conflict')
                              notifyErrorCustom(message);
                              return;
                            }

                            getAllImagesByCategory('Background').length < 1 ?
                              handleOpenImageSelectorModal('Background') : notifyErrorCustom(t('attach_reference_art.background_image_only_one'));
                          }
                        }
                      ]
                    }
                  ]}
                  verticalLayout={true}
                  acceptedFormats="image/*"
                  maxFileSize={10 * 1024 * 1024}
                  showPreview={false}
                />
              </div>
              <div style={{ position: 'relative', width: '100%' }}>
                <textarea
                  id="publication-description-input"
                  className={styles.promptTextarea}
                  value={publicationDescription}
                  onChange={(e) => {
                    publicationDescriptionRef.current = e.target.value;

                    setPublicationDescription(e.target.value);
                  }}
                  placeholder={t('new_publication_page_ia_prompt')}
                  onInput={(e) => {
                    const textarea = e.target;
                    textarea.style.height = '46px';
                    const newHeight = Math.min(textarea.scrollHeight, 200);
                    textarea.style.height = `${newHeight}px`;

                    // Ajusta overflow baseado na altura
                    if (textarea.scrollHeight > 200) {
                      textarea.style.overflowY = 'auto';
                    } else {
                      textarea.style.overflowY = 'hidden';
                    }
                  }}
                  onKeyDown={(e) => {
                    // Ajusta altura imediatamente ao pressionar Enter
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault();
                      nextButtonClick();
                    }

                    if (e.key === 'Enter' && e.shiftKey) {
                      setTimeout(() => {
                        const textarea = e.target;
                        textarea.style.height = 'auto';
                        const newHeight = Math.min(textarea.scrollHeight, 200);
                        textarea.style.height = `${newHeight}px`;

                        if (textarea.scrollHeight > 200) {
                          textarea.style.overflowY = 'auto';
                        } else {
                          textarea.style.overflowY = 'hidden';
                        }
                      }, 0);
                    }
                  }}
                />

                <div style={{ position: 'absolute', left: '0px', top: '0px' }}>
                  {showBeacon && (
                    <Beacon
                      size={36}
                      onHover={() => setShowBeacon(false)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={styles.formatRow}>
            <SelectsFormat
              GenerateArtSteps={GenerateArtSteps}
              formatOptions={formatOptions}
              handleFinishTutorial={handleFinishTutorial}
              renderTourGuide={renderTourGuide}
              selectedFormat={selectedFormat}
              setSelectedFormat={setSelectedFormat}
              setShowFormatModal={setShowFormatModal}
              showFormatModal={showFormatModal}

            />
            {/* <SelectsProduct
            productRef={productRef}
            productTypeOptions={productTypeOptions}
            productValue={productValue}
            setProductValue={setProductValue}
            setShowProductModal={setShowProductModal}
            showProductModal={showProductModal}

          /> */}
          </div>
          <ImageModals />
          <FooterStepRender />
        </div>
      </div>
    </div>
  );
}

export default StepFirstPass;
